import { toast as sonnerToast } from "sonner";
import * as React from "react";

// Type-compatible wrapper for Sonner toast to maintain API compatibility
type ToastProps = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: "default" | "destructive";
  [key: string]: any;
};

// Enhanced toast function that maintains API compatibility
export const toast = ({ title, description, variant, ...props }: ToastProps) => {
  if (variant === "destructive") {
    return sonnerToast.error(title || description || "", {
      description: title ? description : undefined,
      ...props,
    });
  }
  
  return sonnerToast(title || description || "", {
    description: title ? description : undefined,
    ...props,
  });
};

export function useToast() {
  return {
    toast,
    dismiss: (id?: string) => sonnerToast.dismiss(id),
    toasts: [], // Compatibility property, rarely used outside old Toaster component
  };
}
